const config = {
    cbxApiUrl: String(process.env.CBX_API_URL).replace(/\/+$/, ''),
};

export default config;
